/**
 * Pusher event names emitted by ApprovalProcess alert composers
 * (`ApprovalProcessReviewRequestedAlert`, `ReviewSubmittedAlert`, `FinishedAlert`).
 *
 * Channel: `notifications-user-#{userId}`
 */
export const APPROVAL_PROCESS_PUSHER_EVENTS = [
  'approval_process.review_requested',
  'approval_process.review_submitted',
  'approval_process.finished',
] as const;

export type ApprovalProcessPusherEvent = (typeof APPROVAL_PROCESS_PUSHER_EVENTS)[number];
